// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a2d00cf5185328d3","6332":"4d11f6c8f580b59f"}[chunkId] + ".css";
};